module.exports = __webpack_public_path__ + "static/media/gameplay_bg_04.7e758076.jpg";